<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2 class="header">Letters and Forms</h2>
  </div>
</div>
<div class="row row2">
  <div class="col-sm-8 account-details-container">
    <app-manage-letters></app-manage-letters>
    <app-manage-forms></app-manage-forms>
  </div>
  <div class="col-sm-4 current-bill-container right-page-column">
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/letters-forms-container/letters-forms-container.component.html